// @ts-check
/**
 * Prostý klik (FR-2-39; sekce 13 R-8, upřesnění 6 karty B2): jedna sdílená stráž pro moduly, které
 * přebírají klik na odkaz (`list.js` — stránkování, `lib/sector-tree.js` — odkaz stromu oborů).
 * Klik s modifikátorem nebo jiným tlačítkem patří prohlížeči (nové okno, panel), stejně jako klik,
 * který už převzal jiný posluchač (`defaultPrevented`). Žádný stav, žádné texty UI.
 */

/**
 * Levé tlačítko bez modifikátorů — jen takový klik modul převezme (FR-2-39).
 * @param {MouseEvent} event
 */
export function plainClick(event) {
  return (
    event.button === 0 &&
    !event.ctrlKey &&
    !event.shiftKey &&
    !event.metaKey &&
    !event.altKey &&
    !event.defaultPrevented
  );
}
